/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import * as actionTypes from 'Admin/actions/actionTypes.js'
const initState = {
  response: [],
  message: '',
  isAddSpecilization: false,
  isAddSpecilizationError: false,
  AddSpecilization: false,

  isUpdateSpecilization: false,
  isUpdateSpecilizationError: false,
  UpdateSpecilization: false,

  isSpecilizationChangeStatus: false,
  isSpecilizationChangeStatusError: false,
  SpecilizationChangeStatus: false,

  isSpecializationList: false,
  isSpecializationListError: false,
  SpecializationList: false,
}

export default (state = initState, action = {}) => {
  switch (action.type) {
    case actionTypes.ADD_SPECILIZATION_REQUEST:
      return {
        ...state,
        message: '',
        isisAddSpecilizatio: false,
        isisAddSpecilizatioError: false,
      }
    case actionTypes.ADD_SPECILIZATION_SUCCESS:
      return {
        ...state,
        message: 'Data Added Successfully',
        isAddSpeciliData: action.payload.response,
        isAddSpecilizatio: true,
        isAddSpecilizatioError: false,
      }
    case actionTypes.ADD_SPECILIZATION_ERROR:
      return {
        ...state,
        response: action.payload.error,
        message: action.payload.error,
        isAddSpecilizatio: false,
        isAddSpecilizatioError: true
      }

    case actionTypes.GET_UPDATE_SPECILIZATION_REQUEST:
      return {
        ...state,
        message: '',
        isUpdateSpecilization: false,
        isUpdateSpecilizatioError: false,
      }
    case actionTypes.GET_UPDATE_SPECILIZATION_SUCCESS:
      return {
        ...state,
        message: 'Data Updated Successfully',
        isUpdateSpeciliData: action.payload.response,
        isUpdateSpecilization: true,
        isUpdateSpecilizatioError: false,
      }
    case actionTypes.GET_UPDATE_SPECILIZATION_ERROR:
      return {
        ...state,
        response: action.payload.error,
        message: action.payload.error,
        isUpdateSpecilization: false,
        isUpdateSpecilizatioError: true
      }

    case actionTypes.GET_SPECILIZATION_LIST_REQUEST:
      return {
        ...state,
        message: '',
        isSpecializationList: false,
        isSpecializationListError: false,
      }
    case actionTypes.GET_SPECILIZATION_LIST_SUCCESS:
      return {
        ...state,
        message: 'Specialization List',
        SpecializationList: action.payload.response,
        isSpecializationList: true,
        isSpecializationListError: false,
      }
    case actionTypes.GET_SPECILIZATION_LIST_ERROR:
      return {
        ...state,
        response: action.payload.error,
        message: action.payload.error,
        isSpecializationList: false,
        isSpecializationListError: true
      }

    case actionTypes.GET_SPECILIZATION_CHANGE_STATUS_REQUEST:
      return {
        ...state,
        message: '',
        isSpecilizationChangeStatus: false,
        isSpecilizationChangeStatusError: false,
      }
    case actionTypes.GET_SPECILIZATION_CHANGE_STATUS_SUCCESS:
      return {
        ...state,
        message: 'Specialization List',
        SpecilizationChangeStatus: action.payload.response,
        isSpecilizationChangeStatus: true,
        isSpecilizationChangeStatusError: false,
      }
    case actionTypes.GET_SPECILIZATION_CHANGE_STATUS_ERROR:
      return {
        ...state,
        response: action.payload.error,
        message: action.payload.error,
        isSpecilizationChangeStatus: false,
        isSpecilizationChangeStatusError: true
      }


    default:
      return state
  }
}

/********* Show list of Specilization */
